const COOKIES = {
    'media_cookies': 'gdpr-social-deny',
    'marketing-cookies': 'gdpr-marketing-deny',
    'statistics-cookies': 'gdpr-statistics-deny',
    'necessary-cookies': 'gdpr'
}

export const getCookie = (name) => {
    const cookies = document.cookie.split(';').map(c => c.trim());
    const found = cookies.find(c => c.startsWith(name + '='));
    return found ? found.split('=')[1] : null;
};

export const cookieModal = () => {
    document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('cookie-modal');
    const popup = document.getElementById('cookie-popup');

    // Buttons
    const acceptAllBtn = document.getElementById('accept-all-cookies');
    const onlyReqBtn = document.getElementById('accept-req-cookies');
    const acceptAllBtnCustom = document.getElementById('accept-all-cookies-custom');
    const onlyReqBtnCustom = document.getElementById('accept-req-cookies-custom');
    const closeBtn = document.getElementById('close-cookie-modal');
    const customChoicesBtn = document.getElementById('cookie-accept-btn');

    //Popup Buttons
    const rejectCookieBtn = document.getElementById('reject-cookies');
    const manageCookieBtn = document.getElementById('manage-cookies');
    const acceptAllCookiesInPopup = document.getElementById('accept-all-cookies-popup');

    //Footer button
    const manageCookiesFooter = document.getElementById('manage_cookies');

    if (!getCookie('gdpr')) {
        popup.classList.add('show');
    }

    showSetButton();

    rejectCookieBtn.addEventListener('click', () => {
        popup.classList.remove('show');
    })

    manageCookieBtn.addEventListener('click', () => {
        modal.classList.add('show');
    });

    manageCookiesFooter.addEventListener('click', (e) => {
        e.preventDefault();
        modal.classList.add('show');
    })

    closeBtn.addEventListener('click', () => {
        modal.classList.remove('show');
    });

    customChoicesBtn.addEventListener('click', () => {
        setCustomChoices();
        popup.classList.remove('show');
        modal.classList.remove('show');
    });

    [acceptAllBtn, acceptAllBtnCustom, acceptAllCookiesInPopup].forEach((btn) => {
        btn.addEventListener('click', () => {
            setAllCookies();
            popup.classList.remove('show');
            modal.classList.remove('show');
        });
    });

    [onlyReqBtn, onlyReqBtnCustom].forEach((btn) => {
        btn.addEventListener('click', () => {
            setCookie('gdpr','yes',365);
            popup.classList.remove('show');
            modal.classList.remove('show');
        });
    });
})
};

const showSetButton = () => {
    const checkboxes = document.querySelectorAll('.cookie-checkbox');
    const acceptBtn  = document.getElementById('cookie-accept-btn');
    const customActions  = document.getElementById('cookie-actions-custom');
    const defaultActions  = document.getElementById('cookie-actions-default');

    const updateButton = () => {
        const isChecked = [...checkboxes].some(cb => cb.checked);
        acceptBtn.classList.toggle('hidden', !isChecked);
        customActions.classList.toggle('hidden', !isChecked);
        defaultActions.classList.toggle('hidden', isChecked);
    };

    checkboxes.forEach(cb => {
        cb.addEventListener('change', updateButton);
    });

    updateButton();
}

const setCustomChoices = () => {
    setCookie('gdpr','yes',365);
    const checkboxes = document.querySelectorAll('.cookie-checkbox');

    checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
            setCookie(COOKIES[checkbox.id], 'yes', 365);
        }
    });
}
const setAllCookies = () => {
    setCookie('gdpr-statistics-deny','yes',365);
    setCookie('gdpr-marketing-deny','yes',365);
    setCookie('gdpr-social-deny','yes',365);
    setCookie('gdpr','yes',365);
}

const setCookie = (name, value, days) => {
    const d = new Date();
    d.setTime(d.getTime() + days*24*60*60*1000);
    document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
};

